import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import { Divider } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid'
import config from "../../../config/config";
import axios from 'axios';
import { grid_spacing, styles } from '../../CSS/Styles'
import { Radar } from 'react-chartjs-2';

class VendorAnalysis extends React.Component {

	constructor(props) {
		super(props);
    }


    render(){
    	const { classes } = this.props;
    	console.log(this.props.data.address)

        let data = {
            labels: ['Data Quality', 'Timing', 'Unusual Transaction', 'Control Lapses', 'People', 'Conflict Interest'],
            datasets: [{
                label: ' ',
                backgroundColor: 'rgba(0, 145, 218,0.7)',
                borderColor: 'rgba(0, 94, 184,1)',
                pointBackgroundColor: 'rgba(0, 51, 141,1)',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(0, 51, 141,1)',
                data: [6, 7, 3, 1, 2, 4]
            }]
        }
        let option={
            legend: {
                display: false
            },
            scale:{
                pointLabels: {
                    fontSize: 17
                },
                ticks: {
                    beginAtZero: true,
                    maxTicksLimit: 7
                },
                gridLines:{
                   color: 'rgba(0, 94, 184,1)',
                   borderWidth : 2
                }
            },

        }

    	return(
    		<Card className={classes.card_vendor_info}>
    			<CardContent>
    				<Grid container spaceing={grid_spacing} justify="flex-start">
    					<Grid item lg={6} className={classes.content}>
    					   <Radar data={data} options={option}/>
    					</Grid>
                        <Grid item lg={6} className={classes.content}>
                            
                        </Grid>
    				</Grid>
    			</CardContent>
    		</Card>

    	)
    }
}

export default withStyles(styles)(VendorAnalysis)


// WEBPACK FOOTER //
// ./src/components/Entities/vendor/VendorAnalysis.js